import React from 'react'

export const Stats = (props) => {
  const { pageInfo } = props
  let stats = props.stats
  const { count } = pageInfo || {}

  if (stats && typeof stats === 'string') {
    stats = (
      <strong>
        Found <span className="text-primary">{count}</span> {stats}.
      </strong>
    )
  }

  return stats || null
}
